import { pdf } from '@react-pdf/renderer'

import { MyDataPdfDocument } from '../components/MyDataPdfDocument'
import type { MyData } from '../types'

// Exportação client-side: o PDF é gerado no front com @react-pdf/renderer
// (mesmo mecanismo do PDF de respostas das jornadas).
export async function downloadMyDataPdf(data: MyData) {
  const blob = await pdf(<MyDataPdfDocument data={data} />).toBlob()
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = 'meus-dados.pdf'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
